export default __webpack_public_path__ + "static/media/info.26226ad1.svg";